import gql from 'graphql-tag'
import client from '@stores/apollo'
import { INeighborhoodConnectionWithTotal } from '@api/types'
import { NeighborhoodTableRecordFragment } from '@api/fragments'

interface Payload {
  data: {
    viewer: {
      company: {
        neighborhoodConnection: INeighborhoodConnectionWithTotal
      }
    }
  }
}

export interface INeighborhoodVariables {
  first?: number
  orderBy?: string
  after?: string | null
  where?: any
  floorId?: string
}

export default function list(
  variables: INeighborhoodVariables
): Promise<INeighborhoodConnectionWithTotal> {
  return client.gql.query({ query: neighborhoodManagementQuery, variables }).then(
    ({
      data: {
        viewer: {
          company: { neighborhoodConnection },
        },
      },
    }: Payload) => neighborhoodConnection
  )
}

export const neighborhoodManagementQuery = gql`
  query Neighborhoods(
    $after: String
    $orderBy: NeighborhoodOrderByEnum
    $first: Int
    $where: NeighborhoodWhereInput
  ) {
    viewer {
      company {
        neighborhoodConnection(first: $first, after: $after, orderBy: $orderBy, where: $where) {
          counters {
            total
          }
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...NeighborhoodTableRecordFragment
            }
          }
        }
      }
    }
  }
  ${NeighborhoodTableRecordFragment}
`
